var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PaintOptions',{staticClass:"figure-painting__color",attrs:{"options":_vm.colorOptions,"prefix":"color"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var option = ref.option;
return [_c('b-img',{attrs:{"height":40,"width":40,"src":option.image,"alt":"Color icon"}})]}}]),model:{value:(_vm.currentData),callback:function ($$v) {_vm.currentData=$$v},expression:"currentData"}})}
var staticRenderFns = []

export { render, staticRenderFns }